// Import utilities
import { itemsObject } from '@builder-legacy/common/utilities';
import { recipeHasConditions } from '@builder-legacy/item/conditions/utilities';

/**
 * Adds a property to all actions to easily recognize that they have actions
 *
 * @return {undefined}
 */
const flagActionsWithConditions = () => {
	// Check if the recipe has conditions
	if ( recipeHasConditions() ) {
		// Get recipe actions
		const actions = itemsObject( 'get', {
			filter: {
				itemType: 'action',
			},
		} );

		// Add the default flag to all actions
		// The default flag is false
		for ( const actionId in actions ) {
			// Add flag
			UncannyAutomator.recipe.items[ actionId ].hasConditions = false;
		}

		// Iterate conditions to see which ones have conditions
		// eslint-disable-next-line no-unused-vars
		Object.entries( UncannyAutomator.recipe.conditions ).forEach( ( [ conditionsGroupID, conditionsGroup ] ) => {
			// Iterate actions
			conditionsGroup.actions.forEach( ( actionId ) => {
				// Add property to the action to flag that has conditions
				UncannyAutomator.recipe.items[ actionId ].hasConditions = true;
				UncannyAutomator.recipe.items[ actionId ].conditionsGroupID = conditionsGroupID;
			} );
		} );
	}
};

export default flagActionsWithConditions;
